export default __webpack_public_path__ + "static/Noroutine_Website_Cookies_Policy-a6a7caad4816d5abc51c04aa477478bf.pdf";